import { useCallback } from 'react';
import useLabels from './useLabels';
import usePromiseToast from './usePromiseToast';

export const useFileDownloadToast = () => {
    const labels = useLabels();
    const promiseToast = usePromiseToast<boolean>((result) => !!result);

    const handler = useCallback((promise: Promise<boolean>) => {
        promiseToast(promise, {
            pending: labels.downloadingFile,
            success: labels.downloadingFileCompleted,
            fail: labels.downloadingFileFailed,
        });
    }, [labels, promiseToast]);
    return handler;
};
